import { createContext } from 'react'

export const DialogDepthContext = createContext<number>(0)
